import React from "react";
import { useState, useEffect } from "react";
import "../pages/Pages.css";
import applogo from '../svg/appstore-logo.svg'
import whatsappimage from '../svg/whatsapp-image-2023-01-23-at-5-06-2.png'
import phonologo from '../svg/Bunmain.png'
import googleplay from '../svg/rectange.png'


const Bpositive = () => {

    const appClick = () => {
        // "https://apps.apple.com/in/app/aibn/id6449449527"
        window.open("https://apps.apple.com/in/app/business-positive-network/id6446352924");
    }
    const playClick = () => {
        // "https://play.google.com/store/apps/details?id=com.aibn_network.app"
        window.open("https://play.google.com/store/apps/details?id=com.app.business_positive");
    }

    useEffect(() => {
        document.title = "Business Positive";
        document.getElementById("roots").href = whatsappimage;
    }, []);


    return (
        <>
            <div className="wraper">
                <div className="left-screen">
                    <div className="header">
                        <div className="logo">
                            <img src={whatsappimage} />
                        </div>
                        <div className="nav">
                            <div className="text-wrapper">Home</div>
                            <div className="text-wrapper">Contact</div>
                            <div className="text-wrapper">Features</div>
                            <div className="text-wrapper">About</div>
                            <div className="text-wrapper">Events</div>
                        </div>
                    </div>
                    <div className="contaner">
                        <h1 className="text-header">
                            Be the hero of your own success story with{" "}
                            <span className="header-para-BusinessPositive">“BPN Network”</span>
                        </h1>
                        <p className="para-text">
                            At Business Positive Networking, we empower you to be the hero of your own
                            success story. With our platform, you can connect with
                            professionals, access valuable resources, and unlock new
                            opportunities to achieve your goals. Join us today and start your
                            journey towards success.
                        </p>
                        {/* <span className="text-wrapper-21"></span> */}
                    </div>
                    <div>
                        <img className="googleplay" src={applogo} onClick={appClick} />
                        <img className="googleplay" src={googleplay} onClick={playClick} />
                    </div>
                </div>
                <div className="right-screen-BusinessPositive">
                    <div className="download-btn">
                        <button className="btn-down-BusinessPositive"> Download Now</button>
                    </div>
                    <div className="pone-img">
                        <img src={phonologo} />
                    </div>
                </div>
            </div>
        </>
    );
};
export default Bpositive;
